import { render, staticRenderFns } from "./ModalBuy.vue?vue&type=template&id=557090a4&"
import script from "./ModalBuy.vue?vue&type=script&lang=js&"
export * from "./ModalBuy.vue?vue&type=script&lang=js&"
import style0 from "./ModalBuy.vue?vue&type=style&index=0&id=557090a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports